export default __webpack_public_path__ + "static/media/business-image-609bed.da83cffa.png";